import React, { useMemo } from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { appVersionService } from '../../../services/next';

const { Text } = Typography;

const STATUS_OPTIONS = [
  { label: 'Đã duyệt', value: 1 },
  { label: 'Chờ duyệt', value: 0 },
];

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
  { title: 'VERSION', dataIndex: 'version', key: 'version', render: (t) => <Text strong>{t}</Text> },
  { title: 'LINK APK', dataIndex: 'link_apk', key: 'link_apk', render: (t) => t ? <a href={t} target="_blank" rel="noreferrer">Link</a> : '-' },
  { title: 'LINK IPA', dataIndex: 'link_ipa', key: 'link_ipa', render: (t) => t ? <a href={t} target="_blank" rel="noreferrer">Link</a> : '-' },
  { 
    title: 'TRẠNG THÁI', 
    dataIndex: 'status', 
    key: 'status', 
    width: 150, 
    render: (s) => { 
        const map = { 0: ['orange','CHỜ DUYỆT'], 1: ['green','ĐÃ DUYỆT'] }; 
        const [c,l] = map[s] || ['default', s]; 
        return <Tag color={c}>{l}</Tag>; 
    } 
  },
  { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 160, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
];

const QuanLyAppVersion = () => {
  const formFields = useMemo(() => [
    { name: 'version', label: 'Version', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập version!' }] },
    { name: 'link_apk', label: 'Link APK', type: 'input' },
    { name: 'link_ipa', label: 'Link IPA', type: 'input' },
    { name: 'status', label: 'Trạng thái', type: 'select', options: STATUS_OPTIONS, defaultValue: 1 },
  ], []);

  const filterFields = useMemo(() => [
    {
      label: 'Trạng thái',
      value: 'status',
      options: [
        { label: 'Tất cả trạng thái', value: '' },
        ...STATUS_OPTIONS,
      ],
    },
  ], []);

  return (
    <CrudPage
      title="QUẢN LÝ APP VERSION"
      subTitle="Quản lý các phiên bản ứng dụng"
      itemsName="Version"
      queryKey="appVersionList"
      service={appVersionService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm version..."
      addButtonLabel="Thêm version"
      formConfig={{ width: 800 }}
    />
  );
};

export default QuanLyAppVersion;
